import * as React from 'react';
import cn from 'classnames';

import * as styles from './styles.css';

export interface IMarqueeProps {
  mediaNote: string | undefined;
  isRedesignEnabled?: boolean;
}

export class Marquee extends React.Component<IMarqueeProps, {}> {
  private container = React.createRef<HTMLDivElement>();

  public render() {
    const { mediaNote, isRedesignEnabled } = this.props;

    if (!mediaNote) {
      return null;
    }

    return (
      <div
        data-testid="Marquee"
        ref={this.container}
        className={cn(styles['c-filters-text'], isRedesignEnabled && styles['c-filters-text--redesign'])}
        onMouseOver={this.mouseOverHandler}
        onMouseLeave={this.mouseLeaveHandler}
      >
        <span>{this.props.mediaNote}</span>
      </div>
    );
  }

  private mouseOverHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    if (this.container.current) {
      const target = (e.target as HTMLSpanElement) || ({ offsetWidth: 0 } as HTMLSpanElement);
      const containerWith = this.container.current.offsetWidth;
      const childWith = target.offsetWidth;

      const diff = childWith - containerWith;

      if (diff > 0) {
        target.style.transition = `transform ${diff / 100}s linear`;
        target.style.transform = `translate(-${diff}px, 0)`;
      }
    }
  };

  private mouseLeaveHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLSpanElement;

    if (target) {
      target.style.transform = '';
      target.style.transition = '';
    }
  };
}
